import React, {useEffect} from 'react';
import HorizontalGroup from './HorizontalGroup';
import HorizontalCollapse from './HorizontalCollapse';
import HorizontalItem from './HorizontalItem';
import HorizontalSingle from './HorizontalSingle';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import {useSelector} from 'react-redux';
import {authRole} from '../../../../shared/constants/AppConst';
import routesConfig from '../../../../modules/routesConfig';
import mobileroutesConfig from '../../../../modules/mobilerouteconfig';
import Box from '@material-ui/core/Box';
import {Grid, Typography, useMediaQuery, useTheme} from '@material-ui/core';

const HorizontalNav = () => {
  const LoginUser = useSelector(({auth}) => auth.user);
  const prescriptionCount = useSelector(
    ({reportData}) => reportData.reportcount,
  );
  const eRxTabCount = useSelector(({reportData}) => reportData.eRxtabcount);
  const [routeConfigList, setRouteConfigList] = React.useState([]);
  const [mobilerouteConfigList, setMobileRouteConfigList] = React.useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  useEffect(() => {
    if (LoginUser != null) {
      let routingConfig = routesConfig;
      let mobileroutingConfig = mobileroutesConfig;
      if (LoginUser?.roleId == 4) {
        if (LoginUser.sarvoFlow && LoginUser.pharmacyFlow) {
          routingConfig = routesConfig.filter(
            (item) =>
              item.url !== '/pharmacy' && item.url !== '/pharmacydispenced',
          );
          mobileroutingConfig = mobileroutesConfig.filter(
            (item) =>
              item.url !== '/pharmacy' && item.url !== '/pharmacydispenced',
          );
        } else {
          routingConfig = routesConfig.filter(
            (item) =>
              item.url !== '/sarvodhayaPharmacy' &&
              item.url !== '/sarvopharmacydispenced' &&
              item.url !== '/pharmacyCallBackList',
          );
          mobileroutingConfig = mobileroutesConfig.filter(
            (item) =>
              item.url !== '/sarvodhayaPharmacy' &&
              item.url !== '/sarvopharmacydispenced' &&
              item.url !== '/pharmacyCallBackList',
          );
        }
      }

      // if(LoginUser?.roleId ==5 && LoginUser?.testFlow ){
      //   routingConfig.push( {
      //   id: 'callbackListtab',
      //   title: 'callbackListtab',
      //   messageId: 'sidebar.callbacklist',
      //   type: 'single',
      //   icon: 'phone_missed',
      //   auth: authRole.labRoles,
      //   url: '/labAssistCallback',
      // },)
      // mobileroutingConfig.push( {
      //   id: 'callbackListtab',
      //   title: 'callbackListtab',
      //   messageId: 'sidebar.callbacklist',
      //   type: 'single',
      //   icon: 'phone_missed',
      //   auth: authRole.labRoles,
      //   url: '/labAssistCallback',
      // },)
      // }

      // if(LoginUser?.roleId ==6 && LoginUser?.testFlow ){
      //   routingConfig.push( {
      //   id: 'callbackListtab',
      //   title: 'callbackListtab',
      //   messageId: 'sidebar.callbacklist',
      //   type: 'single',
      //   icon: 'phone_missed',
      //   auth: authRole.radiologyRoles,
      //   url: '/radioAssistCallback',
      // },)
      // mobileroutingConfig.push( {
      //   id: 'callbackListtab',
      //   title: 'callbackListtab',
      //   messageId: 'sidebar.callbacklist',
      //   type: 'single',
      //   icon: 'phone_missed',
      //   auth: authRole.radiologyRoles,
      //   url: '/radioAssistCallback',
      // },)
      // }
      if (LoginUser?.billing) {
        routingConfig = routingConfig.map((item) =>
          item.id == 'Prescriptions'
            ? {
                ...item,
                children: [
                  ...item.children,
                  {
                    id: 'billing',
                    title: 'billing',
                    messageId: 'sidebar.billing',
                    type: 'item',
                    auth: authRole.dashboardRoles,
                    url: '/billing',
                    checkauth: true,
                  },
                ],
              }
            : item,
        );
      }
      if (
        LoginUser?.vaccineReminder ||
        LoginUser?.mrdOption ||
        LoginUser?.clienteRxReport ||
        LoginUser?.mediEcho ||
        LoginUser?.registered
      ) {
        let childen = [];
        if (LoginUser?.vaccineReminder) {
          childen.push({
            id: 'Vaccination Report',
            title: 'Vaccination Report',
            messageId: 'sidebar.vaccine',
            type: 'item',
            auth: authRole.dashboardRoles,
            url: '/vaccineReport',
            checkauth: true,
          });
        }

        if (LoginUser?.mrdOption) {
          childen.push({
            id: 'mrd',
            title: 'mrd',
            messageId: 'sidebar.mrd',
            type: 'item',
            auth: authRole.dashboardRoles,
            url: '/mrdReport',
            checkauth: true,
          });
          childen.push({
            id: 'mrd&Lab',
            title: 'mrd&lab',
            messageId: 'sidebar.mrdlab',
            type: 'item',
            url: '/mrdLabReport',
            checkauth: true,
          });
        }
        if (LoginUser?.clienteRxReport) {
          childen.push({
            id: 'eRxReports',
            title: 'eRxReports',
            messageId: 'sidebar.eRxReport',
            type: 'item',
            auth: authRole.dashboardRoles,
            url: '/eRxReport',
          });
        }
        if (LoginUser?.mediEcho) {
          childen.push({
            id: 'mediecho',
            title: 'mediecho',
            messageId: 'sidebar.mediecho',
            type: 'item',
            url: '/mediEchoReport',
            checkauth: true,
          });
        }
        if (LoginUser?.registered) {
          childen.push({
            id: 'sarvodayaReport',
            title: 'Registration vs Digitized Prescriptions',
            messageId: 'sidebar.sarvodayaReport',
            type: 'item',
            url: '/registrationReport',
            checkauth: true,
          });
        }
        routingConfig.push({
          id: 'Reports',
          title: 'Reports',
          messageId: 'sidebar.reports',
          type: 'group',
          auth: authRole.dashboardRoles,
          icon: 'receipt_long',
          children: childen,
        });

        setRouteConfigList(routingConfig);
      } else {
        setRouteConfigList(routingConfig);
      }
      setMobileRouteConfigList(mobileroutingConfig);
    }
  }, [LoginUser]);
  return (
    <>
      <Grid container>
        <Grid item xs={10} sm={10} md={10}>
          <List className='navbarNav'>
            {!isMobile &&
              routeConfigList.map((item) => (
                <React.Fragment key={item.id}>
                  {item.type === 'single' &&
                    item?.auth?.includes(LoginUser.roleId) &&
                    item?.hide != true && (
                      <HorizontalSingle item={item} nestedLevel={0} />
                    )}

                  {item.type === 'group' &&
                    item?.auth?.includes(LoginUser.roleId) && (
                      <HorizontalGroup item={item} nestedLevel={0} />
                    )}

                  {item.type === 'collapse' && (
                    <HorizontalCollapse item={item} nestedLevel={0} />
                  )}

                  {item.type === 'item' && (
                    <HorizontalItem item={item} nestedLevel={0} />
                  )}

                  {item.type === 'divider' && (
                    <Box my={5} clone>
                      <Divider />
                    </Box>
                  )}
                </React.Fragment>
              ))}

            {isMobile &&
              mobilerouteConfigList.map((item) => (
                <React.Fragment key={item.id}>
                  {item.type === 'single' &&
                    item?.auth?.includes(LoginUser.roleId) && (
                      <HorizontalSingle item={item} nestedLevel={0} />
                    )}

                  {item.type === 'group' &&
                    item?.auth?.includes(LoginUser.roleId) && (
                      <HorizontalGroup item={item} nestedLevel={0} />
                    )}

                  {item.type === 'collapse' && (
                    <HorizontalCollapse item={item} nestedLevel={0} />
                  )}

                  {item.type === 'item' && (
                    <HorizontalItem item={item} nestedLevel={0} />
                  )}

                  {item.type === 'divider' && (
                    <Box my={5} clone>
                      <Divider />
                    </Box>
                  )}
                </React.Fragment>
              ))}
          </List>
        </Grid>
        <Grid item xs={2} sm={2} md={2}>
          {eRxTabCount > 0 && prescriptionCount > 0 && (
            <Box
              style={{
                height: '100%',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Typography>
                Total Prescriptions : {prescriptionCount}{' '}
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default HorizontalNav;
